import React from 'react'
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import IconButton from './IconButton';
import CloseIcon from '@material-ui/icons/Close';

function IconCloseButton({
	classes,
	tooltip = Tr('close'),
	...props
}) {
	return <IconButton
		tooltip={tooltip}
		Icon={CloseIcon}
		{...props}
	/>
}

IconCloseButton.propTypes = {
	classes: PropTypes.any,
}

export default IconCloseButton;